import axios, { AxiosError } from "axios";
import type { AxiosInstance, AxiosResponse } from "axios";

// import { setupAuthInterceptor } from "@/utils/setupAuthInterceptor";

const baseURL =
  import.meta.env.VITE_MAESTROS_BACKEND_API_URL || "http://localhost:4001/api";

const catalogoMaestrosApi: AxiosInstance = axios.create({
  baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

// setupAuthInterceptor(catalogoMaestrosApi);

catalogoMaestrosApi.interceptors.response.use(
  (response: AxiosResponse) => response,
  async (error: AxiosError) => {
    return Promise.reject(error.response || "Algo salió mal");
  }
);

export { catalogoMaestrosApi };
